<template>
    <div class="container-fluid h-100">
      <div class="container mt-5 pt-5">
  
          <div class="row mt-5 pt-3">
              <div class="col-12">
              <h4 class="text-left text-dark font-weight-bold">
                  Total de blogs activos: {{ this.totalActiveItems }}
              </h4>
              </div>
               <div class="col-12">
              <h4 class="text-left text-dark font-weight-bold">
                  Total de blogs inactivos: {{ this.totalInactiveItems }}
              </h4>
              </div>
              <div class="col-5 mt-2">
              <input
                  v-model="searchN"
                  type="text"
                  class="form-control"
                  id="exampleFormControlInput1"
                  placeholder="Buscar blog por Nombre"
                  autocomplete="off"
                  v-on:focus="clearInput"
              />
              </div>            
              <div class="col-1 mt-2">
              <button class="btn btn-danger btn-block" @click="search()">
                  <i class="fa fa-search m-0 p-0" aria-hidden="true"></i>
              </button>
              </div>
              <div class="col-3 mt-2">
              <button class="btn btn-info btn-block" @click="createNewBlog()">
                  Crear nuevo blog
              </button>
              </div>
          </div>
  
        <template v-if="loading.history">
          <div class="d-flex justify-content-center">
            <div
              class="spinner-border text-danger"
              style="width: 4em; height: 4rem;"
              role="status"
            ></div>
          </div>
        </template>
  
        <paginate
          v-else
          class="ul-pagination"
          name="items"
          :list="items"
          :per="9"
        >
          <div class="row mt-1">
            <div class="col-12">
              <div class="table-responsive">
                <table class="table table-striped table-sm">
                  <caption class="visually-hidden">Listado de Havoblogs</caption>
                  <thead>
                    <tr>
                      <th scope="col" style="text-align: left">Nombre</th>
                      <th scope="col" style="text-align: left">Título</th>
                      <th scope="col" style="text-align: left">Sub Título</th>
                      <th scope="col" style="text-align: left">Imagen</th>
                      <!-- <th scope="col" style="text-align: left">Promedio de calificación</th> -->
                      <th scope="col" style="text-align: left">Cantidad de vistas</th>
                      <th scope="col" style="text-align: left">Estado</th>
                      <th scope="col" style="text-align: left"></th>
                      <th scope="col" style="text-align: left"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, i) in paginated('items')"
                      :key="'d' + `item-${i}`"
                    >
                      <td style="text-align: left">
                        {{ item.name }}
                      </td>
                      <td style="text-align: left">
                        {{ item.title }}
                      </td>
                      <td style="text-align: left">
                        {{ item.subtitle }}
                      </td>
                      <td style="text-align: left">
                        <img
                          width="100"
                          class="img-item"
                          :src="item.img"
                          :alt="item.name"
                        />
                      </td>
                      <!-- <td style="text-align: left">
                        {{ item.averageScore == null ? 0 : item.averageScore }}
                      </td> -->
                      <td style="text-align: left">
                        {{ item.views == null ? 0 : item.views }}
                      </td>
                      <td style="text-align: left">
                        {{ item.status.name }}
                      </td>
                      <td>
                        <label @click="showComments(item)" v-if="item.status.id == 1" style="color: #3735DF; cursor:pointer;">
                          <span class="fa fa-duotone fa-eye"></span>
                          Ver comentarios ({{ item.havoblog_post_comments.length }})
                        </label>
                      </td>
                      <td style="text-align: left">
                        <label @click="editBlog(item)" v-if="item.status.id == 1" style="color: #dc3545; cursor:pointer;">
                          <span class="fa fa-duotone fa-eye"></span>
                          Editar
                        </label>
                        <label @click="editBlog(item)" v-else style="color: gray; cursor:pointer;">
                          <span class="fa fa-duotone fa-eye"></span>
                          Editar
                        </label>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </paginate>
  
        <div class="row ">
          <div
            class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-12 mt-4 pl-md-5 pl-xl-2"
          >
            <label class="text-p"> Página {{ page }} de {{ totalPage }} </label>
          </div>
          <div
            class="col-12 col-md-9 col-lg-9 col-xl-9 col-sm-12 mt-4 center-paginate"
          >
            <paginate-links
              @change="pageChange"
              for="items"
              :limit="2"
              :show-step-links="true"
              :step-links="{ next: '>', prev: '<' }"
              :classes="{ ul: 'pagination', li: 'page-item', a: 'page-link' }"
            >
            </paginate-links>
          </div>
        </div>
      </div>
    </div>
</template>
  
<script>
  //import $ from "jquery";
  //import * as XLSX from 'xlsx';
  import axios from 'axios';
  
  export default {
    data() {
      return {
        totalActiveItems:0,
        totalInactiveItems:0,
        searchN: "Buscar blog por Nombre",
        loading: {
          history: false,
        },
        items: [],
        paginate: ["items"],
        page: 1,
        totalPage: 1,
      };
    },
    methods: {
      createNewBlog(){
        this.$router.push({ name: "createHavoblog" });
      },
      search(){
        this.totalActiveItems = 0;
        this.totalInactiveItems = 0;
        this.items = [];
        this.loading.history = true;
        const data = {
          filter: this.searchN.length > 0 ? 1 : 0,
          textFilter: this.searchN = ""
        }
        axios
        .post("havoblog/listBlogs", data)
        .then(res => {
          if (res.data.cod == 0) {
            this.items = res.data.data;
            this.totalPage = Math.ceil(parseInt(this.items.length) / 9);
            this.items.forEach(element => {
              if(element.status_id == 1){
                this.totalActiveItems++;
              } else {
                this.totalInactiveItems++;
              }
            });
          }
          this.loading.history = false;
        })
        .catch(error => {
          this.loading.history = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
      },
      editBlog(item){
        this.$router.push({ name: "editHavoblog", params: { blogId: item.id } });
      },
      pageChange(toPage) {
        this.page = toPage;
      },
      showComments(item){
        if(item.havoblog_post_comments.length == 0){
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "info",
            title: "Oops...",
            text: 'No hay comentarios para este blog'
          });
        }else{
          this.$router.push({ name: "commentsHavoblog", params: { blogId: item.id } });
        }
      },
      clearInput() {
        this.searchN = "";
      },
    },
    mounted() {
      this.pageChange(1);
      this.search(); // Peticion para listar los blogs
    },
  };
</script>
  
<style>
  .container-fluid,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl {
    padding-right: 0px !important;
    padding-left: 0px !important;
    overflow: hidden;
  }
  .div-button {
    margin-top: 50px;
    text-align: left;
  }
  .is-danger {
    border: solid 2px !important;
    border-color: #e9434c !important;
  }
  .modal-title {
    color: black;
    font-weight: bold;
  }
  .modal-question {
    border: solid 3px;
    border-color: #dc3545;
    border-radius: 15px;
  }
  label {
    color: black;
    margin-right: 4px;
  }
  .img-banner {
    display: block;
    width: 25%;
    text-align: center;
    margin: auto;
  }
  td {
    text-align: center;
    vertical-align: -webkit-baseline-middle;
    cursor: all-scroll;
  }
  .table-container {
    overflow: auto;
  }
  h5 {
    margin-bottom: 10px !important;
  }
  .commentary {
    text-align: left;
    color: #1da5df;
    font-size: 13px;
  }
  .page-item.active .page-link {
    border-style: none;
    border-radius: 20px;
    background-color: #dc3545;
  }
  a.page-link {
    color: black;
    cursor: pointer;
  }
  a.page-link:hover {
    color: #dc3545;
  }
  .page-link {
    background-color: #f5f5dc00;
    border-radius: 20px;
    border-color: none;
  }
  .page-item.disabled .page-link {
    color: #dc3545;
    background-color: #fff0;
    border-color: #dee2e600;
  }
  .ul-pagination {
    padding: 0px;
  }
  .visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }
</style>
  